import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Expand, Minimize } from '@sweep-io/sweep-design/dist/icons';
import { useCallback } from 'react';
import { AI_AGENTS_EVENTS } from '../../services/events';
import useAgentsHome from './useAgentsHome';
import useSendBiEvent from '../../hooks/useSendBiEvent';
import { useArtifacts } from '../common/artifacts/useArtifacts';

const ToggleExpandButton = () => {
  const { isExpanded, toggleIsExpanded } = useAgentsHome();
  const sendBiEvent = useSendBiEvent();
  const { closeArtifactPanel } = useArtifacts();

  const handleToggleClick = useCallback(() => {
    if (isExpanded) {
      //going to collapse
      closeArtifactPanel();
    } else {
      //going to expand
      sendBiEvent({ name: AI_AGENTS_EVENTS.expand });
    }
    toggleIsExpanded();
  }, [closeArtifactPanel, isExpanded, sendBiEvent, toggleIsExpanded]);

  return (
    <Tooltip placement="top" title={isExpanded ? 'Collapse' : 'Expand'}>
      <span>
        <IconButton variant="flat" onClick={handleToggleClick} size="small">
          {isExpanded ? <Minimize /> : <Expand />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ToggleExpandButton;
